import { render } from "./TacticsContextsRegionFilter.vue?vue&type=template&id=3d2206b8&scoped=true"
import script from "./TacticsContextsRegionFilter.vue?vue&type=script&lang=js"
export * from "./TacticsContextsRegionFilter.vue?vue&type=script&lang=js"

import "./TacticsContextsRegionFilter.vue?vue&type=style&index=0&id=3d2206b8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d2206b8"]])

export default __exports__